module.exports = __webpack_public_path__ + "img/cst2.400e49da.png";